/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_Remove_Segment_LabelInputs */

const en_segment_event_group_remove_segment_label = /** @type {(inputs: Segment_Event_Group_Remove_Segment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove segment`)
};

const fr_segment_event_group_remove_segment_label = /** @type {(inputs: Segment_Event_Group_Remove_Segment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer un segment`)
};

const de_segment_event_group_remove_segment_label = /** @type {(inputs: Segment_Event_Group_Remove_Segment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segment entfernen`)
};

const it_segment_event_group_remove_segment_label = /** @type {(inputs: Segment_Event_Group_Remove_Segment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi segmento`)
};

const ru_segment_event_group_remove_segment_label = /** @type {(inputs: Segment_Event_Group_Remove_Segment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить сегмент`)
};

const es_segment_event_group_remove_segment_label = /** @type {(inputs: Segment_Event_Group_Remove_Segment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar segmento`)
};

const zh_cn2_segment_event_group_remove_segment_label = /** @type {(inputs: Segment_Event_Group_Remove_Segment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除片段`)
};

const ja_segment_event_group_remove_segment_label = /** @type {(inputs: Segment_Event_Group_Remove_Segment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セグメントを削除`)
};

const hi_segment_event_group_remove_segment_label = /** @type {(inputs: Segment_Event_Group_Remove_Segment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खंड हटाएँ`)
};

const pt_pt2_segment_event_group_remove_segment_label = /** @type {(inputs: Segment_Event_Group_Remove_Segment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover segmento`)
};

/**
* | output |
* | --- |
* | "Remove segment" |
*
* @param {Segment_Event_Group_Remove_Segment_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_remove_segment_label = /** @type {((inputs?: Segment_Event_Group_Remove_Segment_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_Remove_Segment_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_segment_event_group_remove_segment_label(inputs)
	if (locale === "de") return de_segment_event_group_remove_segment_label(inputs)
	if (locale === "it") return it_segment_event_group_remove_segment_label(inputs)
	if (locale === "ru") return ru_segment_event_group_remove_segment_label(inputs)
	if (locale === "es") return es_segment_event_group_remove_segment_label(inputs)
	if (locale === "zh-CN") return zh_cn2_segment_event_group_remove_segment_label(inputs)
	if (locale === "ja") return ja_segment_event_group_remove_segment_label(inputs)
	if (locale === "hi") return hi_segment_event_group_remove_segment_label(inputs)
	if (locale === "pt-PT") return pt_pt2_segment_event_group_remove_segment_label(inputs)
	return en_segment_event_group_remove_segment_label(inputs)
});